import React from "react";
import styles from "./Spinner.module.css";

const Spinner: React.FC = () => {
  return (
    <div className={styles.spinner}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles["spinner-icon"]}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 4C12.8174 4 9.76516 5.26428 7.51472 7.51472C5.26428 9.76515 4 12.8174 4 16C4 19.1826 5.26428 22.2348 7.51472 24.4853C9.76515 26.7357 12.8174 28 16 28C19.1826 28 22.2348 26.7357 24.4853 24.4853C26.7357 22.2348 28 19.1826 28 16C28 12.8174 26.7357 9.76516 24.4853 7.51472C22.2348 5.26428 19.1826 4 16 4ZM4.68629 4.68629C7.68687 1.68571 11.7565 0 16 0C20.2435 0 24.3131 1.68571 27.3137 4.68629C30.3143 7.68687 32 11.7565 32 16C32 20.2435 30.3143 24.3131 27.3137 27.3137C24.3131 30.3143 20.2435 32 16 32C11.7565 32 7.68687 30.3143 4.68629 27.3137C1.68571 24.3131 0 20.2435 0 16C0 11.7565 1.68571 7.68687 4.68629 4.68629Z"
          fill="black"
          fillOpacity="0.04"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.1503 6.15298C27.0439 5.50373 28.2947 5.70183 28.9439 6.59545C30.93 9.32901 31.9996 12.6211 31.9996 16C31.9996 19.3789 30.93 22.671 28.9439 25.4046C26.9579 28.1381 24.1574 30.1728 20.9439 31.2169C17.7304 32.261 14.2689 32.261 11.0554 31.2169C10.0048 30.8756 9.42995 29.7473 9.77128 28.6968C10.1126 27.6463 11.2409 27.0714 12.2914 27.4127C14.7015 28.1958 17.2977 28.1958 19.7078 27.4127C22.118 26.6296 24.2183 25.1036 25.7078 23.0534C27.1974 21.0033 27.9996 18.5342 27.9996 16C27.9996 13.4659 27.1974 10.9968 25.7078 8.94659C25.0586 8.05297 25.2567 6.80223 26.1503 6.15298Z"
          fill="black"
          fillOpacity="0.08"
        />
      </svg>
    </div>
  );
};

export default Spinner;
